module.exports = __webpack_public_path__ + "img/vedio01.ced0be90.png";